let timeout = 0;

/**
 * The function will be called after it stops being called for N
 * milliseconds.
 * @param {Function} func
 * @param {Number} wait
 * @param {Boolean?} immediate
 * @return {Function}
 */
const debounce = (func, wait, immediate) => () => {
  const context = this;
  // eslint-disable-next-line
  const args = arguments;
  const later = () => {
    timeout = null;
    if (!immediate) func.apply(context, args);
  };
  const callNow = immediate && !timeout;
  clearTimeout(timeout);
  timeout = setTimeout(later, wait || 200);
  if (callNow) func.apply(context, args);
};

export default debounce;
